var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-dialog', {
    attrs: {
      "max-width": "800"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function (_ref) {
        var on = _ref.on,
          attrs = _ref.attrs;
        return [_vm._t("activator", null, null, {
          attrs,
          on
        })];
      }
    }], null, true),
    model: {
      value: _vm.dialog,
      callback: function ($$v) {
        _vm.dialog = $$v;
      },
      expression: "dialog"
    }
  }, [_c('v-card', {
    staticClass: "contact-dialog"
  }, [_c('v-app-bar', {
    attrs: {
      "flat": "",
      "height": "56",
      "color": "#fff"
    }
  }, [_c('v-spacer'), _c('v-btn', {
    attrs: {
      "color": "#111",
      "text": "",
      "icon": "",
      "aria-label": "닫기"
    },
    on: {
      "click": function ($event) {
        _vm.dialog = false;
      }
    }
  }, [_c('v-icon', [_vm._v("mdi-close")])], 1)], 1), _c('v-divider'), _c('v-card-title', [_c('div', {
    staticClass: "contact-dialog__title"
  }, [_vm._v(" " + _vm._s(_vm.title) + " ")])]), _c('v-card-text', [_c('v-row', {
    staticClass: "row--sm"
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('div', {
    staticClass: "client-title--sm font-weight-bold grey-1--text"
  }, [_vm._v(_vm._s(_vm.business) + " 담당자")])]), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-sheet', {
    staticClass: "border-radius-16 pa-24",
    attrs: {
      "color": "rgba(68,132,26,0.1)"
    }
  }, _vm._l(_vm.items, function (item, index) {
    return _c('v-row', {
      key: index,
      staticClass: "row--sm"
    }, [_c('v-col', {
      attrs: {
        "cols": "12",
        "sm": "auto"
      }
    }, [_c('span', {
      staticClass: "primary--text"
    }, [_vm._v(" " + _vm._s(item.name) + " ")])]), _c('v-col', [_c('a', {
      attrs: {
        "href": item.type === 'tel' ? `tel:${item.text}` : item.type === 'mail' ? `mailto:${item.text}` : item.type === 'link' ? item.text : '#',
        "target": "_blank",
        "rel": "noopener noreferrer"
      }
    }, [_vm._v(" " + _vm._s(item.text) + " ")])])], 1);
  }), 1)], 1)], 1)], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }